<ng-container *ngIf="userId && channel">
  <div class="discussion" [ngClass]="{'discussion--fromPdp': data?.chatFromPdp}">
    <vc-chat-header
      class="discussion__top"
      [channel]="channel"
      [userId]="userId"
      [buyerId]="buyerId"
      [sellerId]="sellerId"
      [channelId]="channelId"
      [product]="product"
      [shippingInformation]="shippingInformation$ | async"
      [negotiation]="negotiation$ | async"
      [receiverInfo]="receiver"
      [isSeller]="isSeller"
      [senderIsBlocked]="senderIsBlocked"
      [receiverIsBlocked]="receiverIsBlocked"
      (blockReceiver)="receiverIsBlocked = $event"
      (activeReportTracking)="trackingChat('report')"
      (displayListMobile)="displayListMobile.emit($event)"
      [isReserved]="isReserved"
      [reservation]="reservation"
      [email]="email"
      [chatFromPdp]="data?.chatFromPdp || false"
    ></vc-chat-header>
    <vc-chat-content
      class="discussion__center"
      [channel]="channel"
      [userId]="userId"
      [receiverInfo]="receiver"
      [isSeller]="isSeller"
      [senderIsBlocked]="senderIsBlocked"
      [receiverIsBlocked]="receiverIsBlocked"
      [senderIsBanned]="senderIsBanned"
      [receiverIsBanned]="receiverIsBanned"
      (senderHasBeenBlocked)="senderIsBlocked = $event"
      [isReserved]="isReserved"
      [reservation]="reservation"
      [openChatFromLike]="openChatFromLike"
      [chatFromPdp]="data?.chatFromPdp || false"
    ></vc-chat-content>
    <vc-chat-form
      class="discussion__bottom"
      [isReserved]="isReserved"
      [reservation]="reservation"
      [senderIsBlocked]="senderIsBlocked"
      [receiverIsBlocked]="receiverIsBlocked"
      [senderIsBanned]="senderIsBanned"
      [receiverIsBanned]="receiverIsBanned"
      [receiverInfo]="receiver"
      (sendMsgTracking)="trackingChat('message_sent')"
    ></vc-chat-form>
  </div>
</ng-container>
